import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import { Icons, Images } from '../../assets';
import Button from '../../component/Button';

const ConfirmationModal = (props) => {
    const { isOpen = false, closePopUp, handleSuccess, warningText = 'Confirmation', confirmText = '', cancelText = '', modalText, primaryBtnConfirm = false, actionSwap = false} = props

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.confirmationModalWrapper} flex items-center `}>
                    <div className={`${classes.warningIcon} flex items-center justify-center`}>
                        <img src={Icons.warning} alt='Warning' />
                    </div>
                    <div className={`${classes.confirmationText}`}>{warningText}</div>
                    {modalText ?
                        <div className={`${classes.modalDescription}`}>{modalText}</div>
                        : null
                    }
                    <div className={`${classes.modalAction} ${actionSwap ? classes.flexReverse : ''}`}>
                        <Button text={cancelText} className={``} smallBtn secondary={primaryBtnConfirm ? false : true} onClick={() => closePopUp()} />
                        <Button text={confirmText} className={``} smallBtn secondary={primaryBtnConfirm ? true : false} onClick={() => handleSuccess()} />
                    </div>
                </div>
            </ModalDropdown>
        </>
    );
}

export default ConfirmationModal